<!-- eslint-disable vue/camelcase -->
<template>
  <div>
    <TitleWrapper
      :filter-option="false"
      title="REQUEST_DETAILS"
      tooltip-title="REQUEST_DETAILS"
      :display-breadcrumb="true"
    ></TitleWrapper>

    <div v-if="!isLoading" class="w-full pt-4">
      <UserDetailedView :user="userCandidate" :detailed-view-is-not-open-in-modal="true" />
      <div v-if="requestLogs.length">
        <div class="font-bold font-roboto text-xl text-label-text">Logs</div>
        <TableWrapper>
          <THead>
            <TRHead>
              <TH v-for="(head, index) in tableHeaders" :key="index">
                {{ head }}
              </TH>
            </TRHead>
          </THead>
          <TBody>
            <TRBody v-for="(log, index) in requestLogs" :key="index">
              <TD>
                {{ requestMessage(log) }}
              </TD>
              <TD>
                <span v-if="log.inserted_at" class="cursor-pointer">
                  {{ $filters.getTimeOnly(log.inserted_at) }}
                </span>
              </TD>
              <TD>
                <span v-if="log.status === 'request_closed' || log.status === 'request_denied'">
                  {{ log.message }}
                </span>
                <span v-else>
                  {{ GENERAL_CONSTANTS.NOT_APPLICABLE }}
                </span>
              </TD>
              <TD>
                {{ log.inserted_by.full_name }}
              </TD>
            </TRBody>
          </TBody>
        </TableWrapper>
      </div>
    </div>
    <div v-else>
      <Loader :content="true" />
    </div>
    <Pagination
      v-if="logsCounts > 10"
      v-show="!isLoading"
      :record-limit="filteredRecordLimit"
      :max-range="paginationCounts(logsCounts, filteredRecordLimit)"
      @filterRecord="getDetails"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import TitleWrapper from '@components/TitleWrapper.vue'
import Pagination from '@components/BaseComponent/Pagination.vue'
import Loader from '@components/BaseComponent/Loader.vue'
import UserDetailedView from '@src/components/userDetailedView.vue'
import GENERAL_CONSTANTS from '@src/constants/general-constants'
import { paginationRangeHandler } from '@src/components/BaseComponent/pagination.util.js'
import { fullName } from '@src/utils/settings/tenant-user.util.js'
import {
  TableWrapper,
  TBody,
  TD,
  TH,
  THead,
  TRBody,
  TRHead,
} from '@src/components/UiElements/TableElements/index.js'
export default {
  components: {
    TitleWrapper,
    Pagination,
    UserDetailedView,
    Loader,
    TableWrapper,
    TBody,
    TD,
    TH,
    THead,
    TRBody,
    TRHead,
  },
  data() {
    return {
      GENERAL_CONSTANTS,
      filteredRecordLimit: 10,
      requestDetails: {},
      userCandidate: null,
      tableHeaders: ['Status', 'Performed At', 'Reason', 'Performed By'],
      isLoading: false,
      requestLogs: [],
      logsCounts: null,
    }
  },
  computed: {
    requestMessage() {
      return (log) => {
        return this.requestedStatus(log)
      }
    },
  },

  page: {
    title: 'Pickup Request Detail',
  },
  mounted() {
    this.getDetails()
  },
  methods: {
    getUserInfo(data) {
      let queryParam = paginationRangeHandler(data?.range, GENERAL_CONSTANTS.MODAL_RECORD_LIMIT)
      let query = {
        id: data?.id,
        payload: queryParam,
      }
      this.isLoading = true
      this.getUserDetails(query)
        .then((res) => {
          this.userCandidate = res.data
          this.userCandidate.requestStatus = this.requestDetails?.status
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    ...mapActions('pickup', ['getRequestDetails']),
    ...mapActions('users', ['getUserDetails']),
    getDetails(range) {
      this.isLoading = true
      let id = this.$route.params?.id

      let payload = {
        skip: range?.skip || GENERAL_CONSTANTS.RECORD_SKIP,
        limit: range?.limit || GENERAL_CONSTANTS.RECORD_LIMIT,
      }
      this.getRequestDetails({ id: id, payload: payload }).then((res) => {
        this.requestDetails = res.pickup_request
        this.isLoading = false
        this.requestLogs = res.records
        this.requestLogs.forEach((log) => {
          fullName(log.inserted_by)
        })
        this.logsCounts = res.meta.total_records
        this.getUserInfo(this.requestDetails.student)
      })
    },
    requestedStatus(log) {
      let message
      switch (log) {
        case 'request_expired':
          message = 'Expired'
          break
        case 'request_sent':
          message = 'Request has Sent'
          break
        case 'request_closed':
          message = 'Closed'
          break
        case 'rerequested':
          message = 'Request Resend'
          break
        case 'request_denied':
          message = 'Rejected'
          break
        case 'student_picked':
          message = 'Student Pickup Up'
          break
        default:
          message = log.message
          break
      }
      return message
    },
  },
}
</script>
